// colors.js

// Light theme color definitions
export const lightColors = {
  primary: '#f8f9fa', // Main color for primary elements, simplified from primaryMain
  primaryContrast: '#fff', // Foreground (text) color on primary elements, adjusted from primaryFg
  secondary: '#b6a37d', // Main color for secondary elements, simplified from secondaryMain
  secondaryContrast: '#202124', // Foreground (text) color on secondary elements, adjusted from secondaryFg
  accent: '#ffff99', // Accent color used for highlighting or emphasis, simplified from accentMain

  background: '#fff', // Background color of the body or main content area, simplified from bodyBg
  text: '#333', // Default text color for body content, simplified from bodyFg
  textMuted: '#666', // Subdued text color for less emphasis, adjusted from bodyQuietColor
  textBold: '#000', // Bold or bright text color for more emphasis, adjusted from bodyLoudColor

  navBackground: '#f8f9fa', // Background color for the navigation bar, adjusted from navBarBg
  navText: '#202124', // Foreground (text) color for the navigation bar, adjusted from navBarFg

  footer: '#f8f9fa', // Background color for the footer, adjusted from footerBg
  footerContrast: '#202124', // Foreground (text) color for the footer, adjusted from footerFg

  widget: '#fff',
  widgetContrast: '#333', // Foreground color for widgets or similar components, simplified from widgetFg
  inputBg: '#fff', // Background color for input boxes in light mode

  link: '#0645ad', // Default link color, adjusted from linkColor
  linkHover: '#036', // Color for links on hover, retained as is
  linkActive: '#5b80b2', // Color for selected or active links, adjusted from linkSelectedFg

  border: '#000', // Default color for borders, simplified from borderColor

  error: '#721c24', // Text color for error messages or elements
  infoBg: '#d1ecf1',
  infoColor: '#0c5460',
  successBg: '#d4edda',
  successColor: '#155724',
  warningBg: '#fff3cd',
  warningColor: '#856404',
  errorBg: '#f8d7da',
  // Backwards compatibility properties
  success: '#d4edda',
  warning: '#fff3cd',
  errorBackground: '#f8d7da',

  darkened: '#f8f8f8', // Slightly darker background color, simplified from darkenedBg
  selected: '#ff0000', // Background color for selected items, simplified from selectedBg
  selectedRow: '#ffc', // Background color for selected table rows or list items, retained as is

  button: '#f8f9fa', // Default background color for buttons, adjusted from buttonBg
  buttonHover: '#609ab6', // Background color for buttons on hover, retained as is
  buttonDefault: '#b6a37d', // Background color for default or secondary buttons, adjusted from defaultButtonBg
  buttonDefaultHover: '#205067', // Hover background color for default or secondary buttons, adjusted from defaultButtonHoverBg

  closeButton: '#747474', // Background color for close buttons, adjusted from closeButtonBg
  closeButtonHover: '#333', // Hover background color for close buttons, adjusted from closeButtonHoverBg

  deleteButton: '#ba2121', // Background color for delete or negative action buttons, adjusted from deleteButtonBg
  deleteButtonHover: '#a41515', // Hover background color for delete or negative action buttons, adjusted from deleteButtonHoverBg

  objectTools: '#747474', // Background color for tool icons or buttons, adjusted from objectToolsBg
  objectToolsHover: '#333', // Hover background color for tool icons or buttons, adjusted from objectToolsHoverBg
  // Dropdown/autosuggest styling
  dropdownBg: '#fff',
  dropdownText: '#333',
  dropdownMutedText: 'rgba(0, 0, 0, 0.54)',
  dropdownHoverBg: '#f0f0f0',
  dropdownDivider: '#ddd',
  dropdownButtonBg: 'rgba(0, 0, 0, 0.04)',
  dropdownButtonText: '#0645ad',
  selectionBg: 'rgba(0,0,0,0.15)',
};

// Dark theme color definitions
const darkBackground = '#1c1c1c';
export const darkColors = {
  primary: '#575757',
  primaryContrast: '#eee',
  secondary: '#686868',
  secondaryContrast: '#ddd',
  accent: '#ffff99',

  background: darkBackground,
  text: '#ccc',
  textMuted: '#ccc',
  textBold: '#fff',

  navBackground: '#575757',
  navText: '#f7f7f7',

  // Match footer background to page background in dark mode
  footer: darkBackground,
  footerContrast: '#f7f7f7',

  widget: '#fff',
  widgetContrast: '#ccc',
  inputBg: '#303030', // Background color for input boxes in dark mode

  link: '#81d4fa',
  linkHover: '#4ac1f7',
  linkActive: '#6f94c6',

  border: '#f7f7f7',

  error: '#e35f5f', // General error color
  infoBg: '#00363a',
  infoColor: '#9ed9e3',
  successBg: '#006b1b',
  successColor: '#d4edda',
  warningBg: '#583305',
  warningColor: '#ffe69b',
  errorBg: '#570808',
  errorColor: '#f8d7da',
  // Backwards compatibility properties
  success: '#006b1b',
  warning: '#583305',
  errorBackground: '#570808',

  darkened: '#212121',
  selected: '#1b1b1b',
  selectedRow: '#00363a',

  button: '#575757',
  buttonHover: '#666666',
  buttonDefault: '#575757',
  buttonDefaultHover: '#666666',

  closeButton: '#333333',
  closeButtonHover: '#666666',

  deleteButton: '#e35f5f',
  deleteButtonHover: '#ba2121',

  objectTools: '#333333',
  objectToolsHover: '#666666',
  // Dropdown/autosuggest styling
  dropdownBg: '#303030',
  dropdownText: '#E5E5E5',
  dropdownMutedText: 'rgba(255,255,255,0.5)',
  dropdownHoverBg: '#3A3A3A',
  dropdownDivider: '#444',
  dropdownButtonBg: 'rgba(255,255,255,0.1)',
  dropdownButtonText: '#10A37F',
  selectionBg: 'rgba(255,255,255,0.2)',
};
